import React, { createContext, useContext, useMemo, useState } from "react";
import emptyFunction from "fbjs/lib/emptyFunction";

interface LivePlaybackUserInteractionContextType {
  isUserInitiatedPlayRequestRequired: boolean;
  setUserInitiatedPlayRequestRequired: (require: boolean) => void;
}

const NonInteractiveLivePlaybackUserInteractionContext: LivePlaybackUserInteractionContextType =
  {
    isUserInitiatedPlayRequestRequired: false,
    setUserInitiatedPlayRequestRequired: emptyFunction,
  };

const LivePlaybackUserInteractionContext =
  createContext<LivePlaybackUserInteractionContextType>(
    NonInteractiveLivePlaybackUserInteractionContext
  );

export const LivePlaybackUserInteractionContextProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [
    isUserInitiatedPlayRequestRequired,
    setUserInitiatedPlayRequestRequired,
  ] = useState<boolean>(false);

  const livePlaybackInteractionContext: LivePlaybackUserInteractionContextType =
    useMemo(
      () => ({
        isUserInitiatedPlayRequestRequired,
        setUserInitiatedPlayRequestRequired,
      }),
      [isUserInitiatedPlayRequestRequired, setUserInitiatedPlayRequestRequired]
    );

  return (
    <LivePlaybackUserInteractionContext.Provider
      value={livePlaybackInteractionContext}
    >
      {children}
    </LivePlaybackUserInteractionContext.Provider>
  );
};

export const NonInteractiveLivePlaybackUserInteractionContextProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <LivePlaybackUserInteractionContext.Provider
    value={NonInteractiveLivePlaybackUserInteractionContext}
  >
    {children}
  </LivePlaybackUserInteractionContext.Provider>
);

export const useLivePlaybackUserInteractionState =
  (): LivePlaybackUserInteractionContextType =>
    useContext(LivePlaybackUserInteractionContext);
